import { render, staticRenderFns } from "./_PASSPORT_ENTITY.vue?vue&type=template&id=6ecb301b&"
import script from "./_PASSPORT_ENTITY.vue?vue&type=script&lang=js&"
export * from "./_PASSPORT_ENTITY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports